export class AudioState {
  backgroundMusic?: HTMLAudioElement;
  musicLoaded = false;
  volume = 1.0;
  muted = false;
}